import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  Grid,
  IconButton,
  MenuItem,
  Select,
  SxProps,
  TextField,
  Typography,
  styled,
} from "@mui/material"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"
import CloseIcon from "@mui/icons-material/Close"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import React, { useEffect, useState } from "react"
import { strFormat } from "../../Table/ResourceBudgetTable/utils"
import { useSelector } from "react-redux"

// height for Menu Items
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

export const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  height: 500,
  bgcolor: "background.paper",
  boxShadow: "0px 3px 6px #00000029",
  borderRadius: "5px",
}

export const OpportunityModalHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  borderBottom: "1px solid #DDDDDC",
  padding: "20px",
})

export const OpportunityDetailsWrapper = styled(Box)({
  padding: "8px 20px 10px 20px",
  position: "relative",
})

export const OpportunityDetailsSubWrapper = styled(Box)({
  display: "flex",
  alignItems: "start",
  flexDirection: "column",
})
export const OpportunityMerticName = styled(Typography)({
  color: "#3C77EF",
  paddingBottom: "10px",
})

export const OpportunityOfficeName = styled(Typography)({
  color: "#000000",
  textTransform: "capitalize",
})

export const OpportunityFields = styled(Box)({
  width: "100%",
  height: "160px",
  marginTop: "10px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
})

export const OpportunityMerticField = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
})

export const OpportunityMerticFieldOne = styled(Box)({
  width: "215px",
  height: "50px",

  flexGrow: 1,
  marginRight: "35px",
})

export const OpportunityMerticFieldTwo = styled(Box)({
  width: "215px",
  height: "50px",

  flexGrow: 1,
})

export const OpportunityMerticDate = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
})

export const OpportunityMerticStartDateOne = styled(Box)({
  width: "215px",
  height: "50px",

  flexGrow: 1,
  marginRight: "35px",
})

export const OpportunityMerticEndDateTwo = styled(Box)({
  width: "215px",
  height: "50px",

  flexGrow: 1,
})

export const OpportunitySetField = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
})

export const OpportunitySetFieldOne = styled(Box)({
  width: "215px",
  height: "50px",

  flexGrow: 1,
  marginRight: "35px",
})

export const OpportunityButtons = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",

  width: "100%",
})
export const ButtonWrapper = styled(Box)({
  display: "flex",
  justifyContent: "space-evenly",
  width: "400px",
  position: "absolute",
  bottom: "30px",
})

export const OpportunityStatus = styled(Box)({
  width: "259px",
  height: "50px",
  border: "1px solid rgba(0, 0, 0, 0.23) ",
  borderRadius: "4px ",
  padding: " 2px",
  flexGrow: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
})
export const CancelButton = styled(Button)({
  width: "156px",
  height: "48px",
  color: "#707070",
})

export const SetButton: any = styled(Button)({
  width: "156px",
  height: "48px",
  color: "#fff",

  backgroundColor: "#3D76EF",
  "&:hover": {
    backgroundColor: "#3D76EF",
  },
  "&:disabled": {
    color: "#FFFFFF",
    backgroundColor: "#707070",
  },
})

export const ActiveIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.929"
    height="19.929"
    viewBox="0 0 19.929 19.929"
  >
    <g
      id="Group_35287"
      data-name="Group 35287"
      transform="translate(-378.123 -6079)"
    >
      <g id="图层_x0020_1" transform="translate(378.123 6079)">
        <circle
          id="Ellipse_515"
          data-name="Ellipse 515"
          cx="9.965"
          cy="9.965"
          r="9.965"
          transform="translate(0 0)"
          fill="#3d76ef"
        />
      </g>
      <g
        id="Layer_2_00000140736130153921798300000016668462501025497243_"
        transform="translate(381.779 5974)"
      >
        <g id="trend_up" transform="translate(-0.006 112)">
          <path
            id="Path_12491"
            data-name="Path 12491"
            d="M.776,119.1a.781.781,0,0,1-.358-.086A.728.728,0,0,1,0,118.251a1.037,1.037,0,0,1,.244-.518c1.231-1.251,2.467-2.482,3.4-3.412a.818.818,0,0,1,.575-.254.856.856,0,0,1,.607.274l2.122,2.122,2.886-2.889-.291,0-1.169-.007a.753.753,0,0,1-.782-.777.786.786,0,0,1,.22-.565.771.771,0,0,1,.555-.22c.587,0,1.172,0,1.737,0l1.744,0a.735.735,0,0,1,.762.748c.007,1.2.007,2.391,0,3.528a.741.741,0,0,1-.78.745h-.01a.747.747,0,0,1-.77-.765c0-.35,0-.706,0-1.048v-.54a.378.378,0,0,0-.032.03q-1.465,1.469-2.928,2.943l-.407.407a1,1,0,0,1-.7.365.983.983,0,0,1-.683-.355l-2.082-2.087-.175.173c-.183.18-.353.35-.521.518l-.785.789c-.451.454-.918.925-1.379,1.386a.818.818,0,0,1-.592.266Z"
            transform="translate(0.006 -112)"
            fill="#fff"
          />
        </g>
      </g>
    </g>
  </svg>
)

const emailRe =
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i

const checkPasswordStrength = (password: string) => {
  if (password.length < 8) {
    return false
  }
  let strength = 0
  if (password.match(/[a-z]+/)) {
    strength += 1
  }
  if (password.match(/[A-Z]+/)) {
    strength += 1
  }
  if (password.match(/[0-9]+/)) {
    strength += 1
  }
  if (password.match(/[$@#&!]+/)) {
    strength += 1
  }

  return strength === 4 ? true : false
}
const validateName = (name: string) => {
  const validName = name?.split(" ").length === 2
  if (!validName) {
    return {
      valid: false,
      message:
        "Full Name field should have firstname and lastname separated by single space",
    }
  }
  return {
    valid: true,
  }
}
const validateEmail = (email: string) => {
  const validEmail = email.toLowerCase().match(emailRe)

  if (!validEmail) {
    return {
      valid: false,
      message: "Provided email is not valid",
    }
  }
  return {
    valid: true,
  }
}
const validatePass = (password: string) => {
  const validPass = checkPasswordStrength(password)

  if (!validPass) {
    return {
      valid: false,
      message:
        "Password should be atleat 8 characters and should include lowercase and uppercase letters, numbers and special characters",
    }
  }
  return {
    valid: true,
  }
}

export const userFields: gridFormFieldType[] = [
  {
    label: "Select Role",
    type: "text",
    placeHolder: "Select a role",
    componentType: 2,
    value: "",
    required: true,
    error: false,
  },
  {
    label: "Full Name",
    type: "text",
    value: "",
    placeHolder: "John Doe",
    componentType: 1,
    required: true,
    error: false,
    validator: validateName,
  },
  {
    label: "Email",
    placeHolder: "john@pronto.com",
    componentType: 1,
    required: true,
    value: "",
    error: false,
    validator: validateEmail,
  },
  // {
  //   label: "Password",
  //   type: "text",
  //   placeHolder: "Password#1234",
  //   componentType: 1,
  //   error: false,
  //   required: true,
  //   value: "",
  //   validator: validatePass,
  // },
]

export const deepCopy = (lst: Array<any>) => {
  return lst.map((item) => {
    return { ...item }
  })
}

export type gridFormFieldType = {
  label: string
  type?: "text" | "number"
  value: string | number | any
  placeHolder: string
  required?: boolean
  componentType: 1 | 2 | 3
  props?: any
  options?: {
    data: string[] | Array<any>
    key?: string
    value?: string
    multiSelect?: boolean
    multiSelectText?: string
  }
  validator?: (value: any) => { valid: boolean; message?: string }
  error: boolean
  errorMessage?: string
}

type modalProps = {
  formState: gridFormFieldType[]
  setState: any
  open: boolean
  formTitle: string
  loading?: {
    now: boolean
    message: string | JSX.Element | null
  }
  closeHandler: any
  optionalText?: string | React.ReactNode
  optionalTextStyles?: SxProps
  confirmButtonText: string
  globalError?: string
  postHandler: Function
  flag?: any
  setFlag?: any
}

export const UserModel = (props: modalProps) => {
  const { formState, open, closeHandler, loading, setState, flag, setFlag } =
    props
  const { formTitle, optionalText, optionalTextStyles } = props
  const { confirmButtonText, postHandler, globalError } = props

  const newUserPractices = useSelector((state: any) => {
    return state.users.newUserPractices
  })

  const [practiceFlag, setPracticeFlag] = useState(0)

  const multipleSelectHandler = (selectEvent: any, index: number) => {
    const { event, child, ops } = selectEvent
    const newState = [...formState]
    let values = []
    const key = ops?.options?.key
    const findKey = child.props.children

    const included = ops?.value?.find((item: any) => {
      if (key) {
        return item[key] === findKey
      }
      return item === findKey
    })

    if (included) {
      values = ops?.value?.filter((item: any) => {
        if (key) {
          return !(item[key] === findKey)
        }
        return !(item === findKey)
      })
    } else {
      const selected = event.target?.value?.filter((item: any) => {
        if (key) {
          return item[key] === findKey
        }
        return item === findKey
      })

      values = (ops?.value || []).concat(selected)
    }

    newState[index].value = values
    setState(newState, index)
  }

  const fieldHandler = (event: any, index: number) => {
    if (index == 4) {
      setFlag(!flag)
    }

    const newState = [...formState]
    newState[index].value = event.target.value
    setState(newState, index)
  }

  const renderSelectedGroups = (list: any, meta: any, index: number) => {
    if (list?.length == 0) {
      return meta?.placeHolder
    }

    const key = meta?.options?.key
    const text = meta?.options?.multiSelectText

    let renderValues = formState?.[index]?.value as any

    if (renderValues?.length < 1) {
      return meta?.placeHolder
    }
    if (renderValues?.length > 1) {
      return `Selected ${renderValues?.length} ${text ? text : "items"}`
    }
    return key ? renderValues?.[0]?.[key] : renderValues?.[0]
  }

  const singleSelectRenderer = (value: any, ops: gridFormFieldType) => {
    if (!value) {
      return ops.placeHolder
    }

    return value
  }

  const disabled = React.useMemo(() => {
    let disable = false
    formState.forEach((field) => {
      if (field.required) {
        if (field.options?.multiSelect && field.value.length < 1) {
          disable = true
        }
        if (!field.value) {
          disable = true
        }
      }
    })
    return disable
  }, [formState])

  const submitHandler = () => {
    let failed = false
    let payload: any = {}
    const newErrorState = [...formState]
    formState.forEach((field, index) => {
      const validated = field?.validator?.(field.value)
      if (validated) {
        if (!validated.valid) {
          newErrorState[index].error = true
          newErrorState[index].errorMessage = validated.message
          failed = true
        } else {
          newErrorState[index].error = false
          newErrorState[index].errorMessage = ""
        }
      }
      payload[field.label] = field.value
    })

    if (failed) {
      setState(newErrorState)
    }
    !failed && postHandler(payload)

    useEffect(() => {
      if (newUserPractices?.length) {
        setPracticeFlag(1)
      }
    }, [newUserPractices])
  }

  return (
    <Dialog open={open} onClose={closeHandler} maxWidth="sm">
      {loading?.now ? (
        <Box
          sx={{
            flexDirection: "column",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
            my: 18,
            minWidth: "600px",
            maxWidth: "600px",
          }}
        >
          <CircularProgress />
          {loading.message && (
            <Typography
              sx={{
                mt: "10px",
                mx: "40px",
                textAlign: "center",
                lineHeight: 2,
              }}
            >
              {loading.message}
            </Typography>
          )}
        </Box>
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              py: 1,
              alignItems: "center",
              borderBottom: "1px solid lightgrey",
            }}
          >
            <Typography sx={{ fontWeight: "bold", pl: 2 }}>
              {formTitle}
            </Typography>
            <IconButton sx={{ mr: 1 }} onClick={closeHandler}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ pt: 1.5 }}>
            {globalError && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <ErrorOutlineIcon sx={{ color: "red" }} />
                <Typography
                  sx={{
                    textAlign: "center",
                    mb: "8px",
                    mt: "3px",
                    color: "red",
                    fontSize: "12px",
                  }}
                >
                  {globalError}
                </Typography>
              </Box>
            )}
            <Grid container spacing={1.5} sx={{ px: 2, pb: 2, mt: "1px" }}>
              {formState.map((ops: gridFormFieldType, index: any) => {
                const multiple = ops.options?.multiSelect
                if (ops.componentType === 1) {
                  return (
                    <Grid item xs={6} key={`text-${index}`}>
                      <Typography sx={{ fontSize: "12px", mb: 0.5 }}>
                        {ops.label} {ops.required && " *"}
                      </Typography>
                      <TextField
                        error={ops.error}
                        key={ops.label}
                        value={ops.value}
                        onChange={(event) => fieldHandler(event, index)}
                        required={ops?.required}
                        placeholder={ops?.placeHolder}
                        type={ops?.type}
                        fullWidth
                        variant="outlined"
                      />
                      {ops.error && (
                        <Typography
                          sx={{
                            fontSize: "9px",
                            color: "red",
                            mt: 0.5,
                            pl: 0.5,
                          }}
                        >
                          {ops?.errorMessage}
                        </Typography>
                      )}
                    </Grid>
                  )
                }
                if (ops.componentType === 2) {
                  return (
                    <Grid item xs={6} key={`select-${index}`}>
                      <Typography sx={{ fontSize: "12px", mb: 0.5 }}>
                        {ops.label} {ops.required && " *"}
                      </Typography>
                      <Select
                        key={ops.label}
                        multiple={multiple}
                        error={ops.error}
                        displayEmpty
                        inputProps={{ "aria-label": "Select a group(s)" }}
                        onChange={(event, child) => {
                          multiple
                            ? multipleSelectHandler(
                                { event, child, ops },
                                index,
                              )
                            : fieldHandler(event, index)
                        }}
                        fullWidth
                        renderValue={
                          multiple
                            ? (list: any) =>
                                renderSelectedGroups(list, ops, index)
                            : (selected: any) =>
                                singleSelectRenderer(selected, ops)
                        }
                        IconComponent={ExpandMoreIcon}
                        value={
                          multiple
                            ? ops?.value
                              ? ops?.value
                              : []
                            : ops?.value?.[ops.options?.value as string]
                        }
                        MenuProps={{
                          sx: {
                            px: 1,
                            width: "250px",
                            height: "350px",
                          },
                        }}
                        variant="outlined"
                      >
                        {ops?.options?.data?.map((option, itemIndex) => {
                          const key = ops?.options?.key
                          const value = ops?.options?.value
                          return (
                            <MenuItem
                              key={`select-${index}-${itemIndex}`}
                              value={
                                multiple
                                  ? option
                                  : value
                                  ? option[value]
                                  : option
                              }
                              sx={{
                                fontWeight: "bold",
                                m: 1,
                                borderRadius: "5px",
                                whiteSpace: "normal",
                              }}
                            >
                              {value ? option[value] : option}
                            </MenuItem>
                          )
                        })}
                      </Select>
                      {ops.error && (
                        <Typography
                          sx={{
                            fontSize: "9px",
                            color: "red",
                            mt: 0.5,
                            pl: 0.5,
                          }}
                        >
                          {ops?.errorMessage}
                        </Typography>
                      )}
                    </Grid>
                  )
                }
              })}
            </Grid>
          </Box>
          {optionalText && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                px: 2,
                mb: 2,
                color: "#3D76EF",
                ...optionalTextStyles,
              }}
            >
              {optionalText}
            </Box>
          )}
          <Box sx={{ display: "flex", flex: 1, columnGap: 1, mb: 2, mx: 2 }}>
            <Button
              variant="outlined"
              fullWidth
              onClick={closeHandler}
              sx={{ py: 1 }}
            >
              Cancel
            </Button>
            <Button
              disabled={disabled}
              variant="contained"
              fullWidth
              onClick={submitHandler}
              sx={{ py: 1 }}
            >
              {confirmButtonText}
            </Button>
          </Box>
        </>
      )}
    </Dialog>
  )
}
